import { Component, Input, OnInit } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RoomsService } from '../../../core/services/rooms.service';
import { BookableBy } from '../../../core/models/common/bookable-by';
import { Room } from '../../../core/models/entities/room';
import { ApiError } from '../../../core/models/common/api-error';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-create-duplicate-room-modal',
  template: `
    <app-modal [modalInstance]="modalInstance" (onOk)="onSubmit()">
      <app-text-input
        label="Nom de la salle"
        name="name"
        [control]="form.get('name')"
      ></app-text-input>
    </app-modal>
  `,
  standalone: false,
})
export class CreateDuplicateRoomModalComponent
  extends ModalBaseComponent
  implements OnInit
{
  @Input() originalRoom: Room;
  sendingData: boolean;
  form: UntypedFormGroup;
  constructor(
    private roomsService: RoomsService,
    private formValidationService: FormValidationService,
    private toastService: ToastService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
    });
  }

  async onSubmit() {
    if (this.formValidationService.validate(this.form)) {
      try {
        this.modalInstance.saving = true;
        let room: Room;
        if (this.originalRoom) {
          room = await this.roomsService.duplicate(this.originalRoom.id, {
            ...this.form.value,
            bookable_by: BookableBy.Private,
          });
        } else {
          room = await this.roomsService.store({
            ...this.form.value,
            bookable_by: BookableBy.Private,
          });
        }
        await this.router.navigate(['/salles/', room.id]);
      } catch (exception) {
        this.formValidationService.displayApiValidationErrors(
          this.form,
          exception as ApiError,
        );
      } finally {
        this.modalInstance.saving = false;
      }
    }
  }
}
